<template>
    <router-link tag="li"
                 :to="{name:'list',query:{q:text.id1}}"
                 exact-active-class="active"
    class="border-bottom"
    ><a>
        <b-icon icon="person-fill"></b-icon>
        {{text.name}} </a><br/><small>{{text.post}}</small></router-link>
</template>

<script>
    export default {
        name: "ListLecturers",
        props: {text:Array},

    }
</script>

<style scoped>
    a:hover, a:active, a {
        text-decoration: none;
    }

    .active a {
        color: red;

    }
.active{
    background-color: rgba(255,0,0,.05);
}
</style>